import { Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { NavWrapper, NavItemWrapper } from '../styles';

interface IProps {
    activeKey: string,
    onTabSelect: (key: string) => void
}

const WatrNav = (props: IProps) => {
    const wageTooltip = (
        <Tooltip id="wage-tooltip">
            Wage &amp; Travel
        </Tooltip>
    );

    return (
        <NavWrapper fontSize='12px'>
            <Nav bsStyle='tabs' className='acc-tabs' activeKey={props.activeKey}>
                {/* AS - BM-4911 - Leave in here for now, in case they want to put these reports back in */}
                {/* <NavItemWrapper href={'/admin/reports/dash-board/compare-conversion'} target='_self'>
                    DASHBoard
                </NavItemWrapper>
                <NavItemWrapper href={'/admin/dash/donor-intake/search'} target='_self'>
                    PWL
                </NavItemWrapper>
                <NavItemWrapper href={'/admin/microsite/pending-nkr'} target='_self'>
                    Microsites
                </NavItemWrapper>
                <NavItemWrapper href={__OUTSIDEURL__ + '/admin/follow-up/index'} target='_self'>
                    Follow-Up
                </NavItemWrapper> */}
                <OverlayTrigger placement="bottom" overlay={wageTooltip} trigger={['hover', 'focus']}>
                    <NavItemWrapper active={props.activeKey === 'WATR'} href={'/admin/dash/watr'} target="_self">
                        Donor Shield Claims Processing
                    </NavItemWrapper>
                </OverlayTrigger>
            </Nav>
        </NavWrapper>
    );
}

export default WatrNav;